import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { IconTicket } from 'components/Icons';

const LoadingSpinner = ({ isActive }) => {
  return (
    <div
      className={classnames({
        'syos-loader': true,
        'syos-loader--active': isActive
      })}
    >
      <div className="syos-progress-bar" />
      <div className="syos-loader__content">
        <span className="syos-loader__message">
          <IconTicket />
          Loading seat availability...
        </span>
      </div>
    </div>
  );
};
LoadingSpinner.propTypes = {
  isActive: PropTypes.bool.isRequired
};

export default LoadingSpinner;



// WEBPACK FOOTER //
// ./src/javascripts/components/LoadingSpinner.js